import * as R from 'ramda'
import { handleActions } from 'redux-actions'

import actions from './actions'

const defaultState = {
  capabilities: {
    hasInitialised: false,
    isFetching: false,
    error: undefined,
    value: undefined
  }
}

export default handleActions({
  [actions.capabilities.loading]: R.assocPath(['capabilities', 'isFetching'], true),
  [actions.capabilities.set]: (state, { error, payload }) => ({
    ...state,
    capabilities: {
      hasInitialised: true,
      isFetching: false,
      error: error ? payload : undefined,
      value: error ? {} : payload.data.capabilities
    }
  })
}, defaultState)
